export enum OrganizationEnum {
  Apollo = 213,
  XO = 8,
}
